import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import FirebaseAccountManagement from './views/FirebaseAccountManagement';
import PrivacyPolicy from './views/PrivacyPolicy';
import Payments from '@/views/Payments';
import Login from '@/components/Login/Login';
import Dashboard from '@/views/Dashboard';
import store from '@/store';
import AccountRegistration from '@/views/AccountRegistration';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/account-management',
      name: 'accountManagement',
      component: FirebaseAccountManagement,
      beforeEnter: (to, from, next) => {
        let mode = to.query.mode;
        let oobCode = to.query.oobCode;

        if (!mode || !oobCode) {
          console.error('No need to access account management.');
          next('/')
        } else {
          next();
        }
      }
    },
    {
      path: '*',
      component: Home
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/account-registration',
      name: 'accountRegistration',
      component: AccountRegistration
    }
    // {
    //   path: '/payments',
    //   name: 'payments',
    //   component: Payments,
    // }
    // {
    //     path: '/types',
    //     name: 'types',
    //     component: () => import('./views/Types')
    // }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})
